module.exports = __webpack_public_path__ + "img/mint-right-storm.a062e648.svg";